import { render, staticRenderFns } from "./DetailCaceList.vue?vue&type=template&id=c40b4a38&scoped=true&"
import script from "./DetailCaceList.vue?vue&type=script&lang=js&"
export * from "./DetailCaceList.vue?vue&type=script&lang=js&"
import style0 from "./DetailCaceList.vue?vue&type=style&index=0&id=c40b4a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40b4a38",
  null
  
)

export default component.exports